import './tableToolbar.scss';

import cn from 'classnames';
import { motion } from 'framer-motion';
import React, { HTMLAttributes } from 'react';

interface ITableToolbarProps extends HTMLAttributes<HTMLDivElement> {
  customFilters?: React.ReactNode;
  customActions?: React.ReactNode;
  additional?: React.ReactNode;
}

const TableToolbar: React.FC<ITableToolbarProps> = ({
  customFilters,
  customActions: CustomActions,
  additional: Additional,
  ...props
}) => {
  return (
    <motion.div
      animate={{ height: 'auto', overflow: 'hidden' }}
      className={cn('mm-common-table-toolbar', props.className)}
    >
      <div className="mm-common-table-toolbar__custom-filters">{customFilters}</div>
      <div className="mm-common-table-toolbar__custom-actions">
        {Additional && Additional}
        {CustomActions}
      </div>
    </motion.div>
  );
};

export { TableToolbar };
